type PropsType = {
  stroke?: string;
};
const ListViewIcon = ({ stroke }: PropsType) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame">
        <path
          id="Vector"
          d="M6.5 2H3.16667C2.79848 2 2.5 2.29848 2.5 2.66667V6C2.5 6.36819 2.79848 6.66667 3.16667 6.66667H6.5C6.86819 6.66667 7.16667 6.36819 7.16667 6V2.66667C7.16667 2.29848 6.86819 2 6.5 2Z"
          stroke={stroke || '#015C9A'}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M6.5 9.33337H3.16667C2.79848 9.33337 2.5 9.63185 2.5 10V13.3334C2.5 13.7016 2.79848 14 3.16667 14H6.5C6.86819 14 7.16667 13.7016 7.16667 13.3334V10C7.16667 9.63185 6.86819 9.33337 6.5 9.33337Z"
          stroke={stroke || '#015C9A'}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M9.8335 2.66663H14.5002"
          stroke={stroke || '#015C9A'}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M9.8335 6H14.5002"
          stroke={stroke || '#015C9A'}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_5"
          d="M9.8335 10H14.5002"
          stroke={stroke || '#015C9A'}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_6"
          d="M9.8335 13.3334H14.5002"
          stroke={stroke || '#015C9A'}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default ListViewIcon;
